import { render, staticRenderFns } from "./YlHotelApiConfigure.vue?vue&type=template&id=295902c0&scoped=true"
import script from "./YlHotelApiConfigure.vue?vue&type=script&lang=js"
export * from "./YlHotelApiConfigure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295902c0",
  null
  
)

export default component.exports